export class JobArrangerRoutes
{
	static Home: string = '/';
	static Dashboard: string = '/dashboard';
    
	//Job
	static JobList: string = '/job/list';
	static JobNew: string = '/job/new';
	static JobCopy(id: string)
	{
		return `/job/${id}/new`;
	}
	static JobEdit(id: string)
	{
		return `/job/${id}/edit`;
	}
	static JobView(id: string)
	{
		return `/job/${id}/view`;
	}
    
	//Reason
	static ReasonList: string = '/reason/list';
	static ReasonNew: string = '/reason/new';
	static ReasonCopy(id: string)
	{
        return `/reason/${id}/new`;
	}
	static ReasonEdit(id: string)
	{
		return `/reason/${id}/edit`;
	}
	static ReasonView(id: string)
	{
		return `/reason/${id}/view`;
	}

    // Platform
    static PlatformList: string = '/platform/list';
}